import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/sell/deleteaction";
import getitemaction from "../../context/action/return/getitemaction";
import createaction from "../../context/action/return/createaction";

const Sellinvoicedetailmodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [barcode, setbarcode] = useState();
  const [items, setitems] = useState([]);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full md:w-4/5 lg:w-5/6">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => {
                      props.setshow(false);
                      setitems([]);
                      props.setinvoice_detail();
                    }}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative h-[65vh] sm:h-[70vh] overflow-y-auto p-3 sm:p-6">
                  <div className="flex flex-wrap w-full">
                    {/* Barcode Input */}
                    <div className="w-full px-2 sm:px-3 my-2">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        ناوی ئایتم / باڕکۆد
                      </label>
                      <input
                        className="appearance-none block w-full bg-white text-black border border-gray-200 rounded py-2 sm:py-3 px-3 sm:px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        id="grid-last-name"
                        type="text"
                        onClick={(val)=>{val.target.select()}}
                        value={barcode}
                        onChange={(val) => setbarcode(val.target.value)}
                        autoFocus
                        onKeyDown={(key) => {
                          if (key.key == "Enter") {
                            getitemaction(barcode)(recaller)(setrecaller)(
                              items
                            )(setitems)(setbarcode)(props.invoice_detail.items);
                          }
                        }}
                      />
                    </div>

                    {/* Return Items Table */}
                    {items.length > 0 && (
                      <div className="w-full mb-3 overflow-x-auto">
                        <div className="py-2 text-sm sm:text-base">لیستی گەڕانەوەی کاڵا</div>
                        <div className="min-w-full overflow-hidden rounded-lg shadow">
                          <table className="min-w-full leading-normal">
                            <thead>
                              <tr>
                                <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                  ناوی کاڵا
                                </th>
                                <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                  باڕکۆد
                                </th>
                                <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                  جۆر
                                </th>
                                <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                  بڕی گەڕاوە
                                </th>
                                <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                  نرخی فرۆشراو
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((lis, index) => (
                                <tr key={index}>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 bg-white text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_name}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 bg-white text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_barcode}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 bg-white text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      کاڵا
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 bg-white text-xs sm:text-sm">
                                    <input
                                      className={
                                        "appearance-none block w-full bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                      }
                                      id="grid-last-name"
                                      type="number"
                                      onClick={(val)=>{val.target.select()}}
                                      value={lis.item_qty}
                                      onChange={(val) => {
                                        if (
                                          Number(
                                            props.invoice_detail.items.filter(
                                              (rs) =>
                                                rs.item_barcode ==
                                                lis.item_barcode
                                            )[0].item_qty
                                          ) >= Number(val.target.value)
                                        ) {
                                          setitems(
                                            items.map((rs, indexx) =>
                                              lis.item_id == rs.item_id
                                                ? {
                                                    item_id: rs.item_id,
                                                    item_name: rs.item_name,
                                                    item_barcode: rs.item_barcode,
                                                    item_sell_price:
                                                      rs.item_sell_price,
                                                    item_return_price:
                                                      rs.item_return_price,
                                                    item_qty: val.target.value,
                                                  }
                                                : rs
                                            )
                                          );
                                        } else {
                                          alert("بڕی گەڕاوە هەڵەیە");
                                        }
                                      }}
                                    />
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 bg-white text-xs sm:text-sm">
                                    <input
                                      className={
                                        "appearance-none block w-full bg-gray-100 text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                      }
                                      id="grid-last-name"
                                      type="number"
                                      placeholder="3.14"
                                      value={lis.item_return_price}
                                      disabled
                                      onChange={(val) => {
                                        setitems(
                                          items.map((rs, indexx) =>
                                            lis.item_id == rs.item_id
                                              ? {
                                                  item_id: rs.item_id,
                                                  item_name: rs.item_name,
                                                  item_barcode: rs.item_barcode,
                                                  item_sell_price:
                                                    rs.item_sell_price,
                                                  item_return_price:
                                                    val.target.value,
                                                  item_qty: rs.item_qty,
                                                }
                                              : rs
                                          )
                                        );
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Main Items Table */}
                    <div className="w-full overflow-x-auto">
                      <div className="min-w-full overflow-hidden rounded-lg shadow">
                        <table className="min-w-full leading-normal">
                          <thead>
                            <tr>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                ناوی کاڵا
                              </th>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                باڕکۆد
                              </th>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                جۆر
                              </th>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                بڕی فرۆشراو
                              </th>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                نرخی کاڵا
                              </th>
                              <th className="px-3 sm:px-5 py-2 sm:py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs sm:text-sm font-semibold">
                                نرخی فرۆشراو
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props?.invoice_detail?.items?.map((lis, index) => (
                              lis.item_qty > 0 && (
                                <tr key={index} className={`${lis.item_type === "service" ? 'bg-gray-50' : 'bg-white'}`}>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_name}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_barcode}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                    {lis.item_type==="service"?"خزمەتگوزاری":"کاڵا"}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_qty}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_price}
                                    </p>
                                  </td>
                                  <td className="px-3 sm:px-5 py-2 sm:py-3 border-b border-gray-200 text-xs sm:text-sm">
                                    <p className="text-gray-900 whitespace-nowrap">
                                      {lis.item_sell_price}
                                    </p>
                                  </td>
                                </tr>
                              )
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-wrap sm:flex-nowrap items-center justify-end gap-2 p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded shadow hover:shadow-lg"
                    onClick={() => {
                      if (
                        window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                      ) {
                        deleteaction(props.invoice_detail.sell_invoice_id)(
                          recaller
                        )(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className={`w-full sm:w-auto ${
                      items.length > 0
                        ? "bg-emerald-500 active:bg-emerald-600"
                        : "bg-emerald-300"
                    } text-white font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded shadow hover:shadow-lg`}
                    disabled={items.length === 0}
                    onClick={() => {
                      createaction(
                        props.invoice_detail.sell_invoice_id,
                        "",
                        items,
                        initState.token.id
                      )(recaller)(setrecaller)(initDispatch)(clear);
                    }}
                  >
                    گەڕانەوەی کاڵا
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Sellinvoicedetailmodal;
